<template>
	<div class="container">

		<!-- Loading加载 -->
		<div class="loading" v-if="isDetail">
			<van-loading size="40px" type="spinner" color="#39CCCD" vertical>
				<div class="loading-text">
					<div>页面正在加载</div>
					<div>请稍候</div>
				</div>
			</van-loading>
		</div>

		<div v-show="!isDetail">
			<div class="code_top">
				<img src="@/assets/userInfo_code01.png" class="ic_success" />
			</div>
			<div class="code_top2">
				<div style="font-size: 20px;font-weight: 600;margin-top: 30px;">还差最后一步</div>
				<div style="font-size: 18px;margin-top: 20px;">添加辅导老师，马上激活课程！</div>

				<img src="@/assets/userInfo_code02.png" class="ic_success" />
				<div style="font-size: 14px;color: #999;">全程学习跟踪服务，添加老师后方可学习！</div>
			</div>
			<div class="finger" @click="getWxInfo()">添加辅导老师</div>
		</div>
	</div>
</template>

<script>
var that;
import { Toast } from 'vant';
export default {
	name: 'userInfo_code',
	components: {},
	props: {},
	data() {
		return {
			isDetail: true,
			code: '',
			token: '',
		}
	},
	created() {
		that = this;
		that.token = localStorage.getItem('token')
		setTimeout(() => {
			that.isDetail = false;
		}, 500);
		//有code并且已经登录跳转老师二维码页
		const queryObj = this.getQueryObj()
		if (queryObj['code'] && that.token) {
			that.btnWXcode()
		}
	},
	methods: {
		//支付成功后获取微信昵称头像
		getWxInfo() {
			Toast.loading({
				message: '加载中',
				forbidClick: true,
				loadingType: 'circular'
			});
			console.log('获取vx授权code')
			window.location.replace(`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd06acaafd7167053&redirect_uri=${encodeURIComponent(window.location.href + '#' + new Date().getTime())}&response_type=code&scope=snsapi_userinfo#wechat_redirect`)
		},

		to_link() {
			this.$router.push({
				path: '/smallprogram/success'
				// query: { id: this.id }
			})
		},

		btnWXcode() {
			const queryObj = this.getQueryObj()
			this.$http.get('/app/users/mergeMpInfo', {
				code: queryObj['code']
			}).then(res => {
				console.log(res)
				setTimeout(() => {
					that.to_link()
				}, 500);
			})
		},

		getQueryObj() {
			var query = location.search
			var queryObj = {}
			var arr = query.slice(1, query.length).split('&')
			arr.forEach(function (val) {
				var arr1 = val.split('=')
				queryObj[arr1[0]] = arr1[1]
			})

			return queryObj
		},

	}
}
</script>

<style scoped lang="less">
.finger {
	padding: 30px;
	background-color: #ff5725;
	line-height: 40px;
	font-weight: 500;
	font-size: 40px;
	width: 50%;
	border-radius: 100px;
	text-align: center;
	color: #ffffff;
	margin: 100px auto;
	animation: identifier .7s linear infinite;
}

@keyframes identifier {
	0% {
		transform: scale(.95);
	}

	50% {
		transform: scale(1.02);
	}

	100% {
		transform: scale(.95);
	}
}

.code_top2 {
	text-align: center;

	.ic_success {
		width: 52%;
		margin: 0 auto;
		display: block;
		margin-top: 30px;
		margin-bottom: 20px;
	}
}

.code_top {
	background: linear-gradient(90deg, #ff9d00 0%, #ff7916 100%);

	.ic_success {
		width: 100%;
		margin: 0 auto;
		display: block;
		margin-bottom: 20px;
	}
}


.loading {
	margin: 40vh auto;
	text-align: center;

	.loading-text {
		color: #39CCCD;
		font-weight: bold;
	}
}
</style>